import * as React from "react";
const SvgChevronLeft = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "#000000", width: 240, height: 240, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z" }));
export default SvgChevronLeft;
